const gradientPaperStyle = {
  background: {
    background: "linear-gradient(#FFFFFF, #F4F7FF) !important",
  },
};

export default gradientPaperStyle;
